var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAngulareReady
    ? _c("div", { staticClass: "ae2-widget-menu", class: _vm.menuClass }, [
        !_vm.isLogged
          ? _c("div", { staticClass: "ae2-widget-menu-group" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.loginMode == "v1"
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "ae2-widget-menu-btn ae2-widget-menu-btn__primary",
                        on: { click: _vm.showLoginModal }
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.buttonsConfig.loginBtnText))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "ae2-widget-menu-btn ae2-widget-menu-btn__secondary",
                        on: { click: _vm.showSignupModal }
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.buttonsConfig.signupBtnText))
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loginMode == "v2"
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "ae2-widget-menu-btn ae2-widget-menu-btn__primary",
                        on: { click: _vm.showLoginSignupModal }
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.buttonsConfig.loginBtnText))
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isLogged
          ? _c("div", { staticClass: "ae2-widget-menu-group" }, [
              _c("div", { staticClass: "ae2-widget-menu-message" }, [
                _c("p", { staticClass: "ae2-widget-menu-title" }, [
                  _vm._v("\n        Olá! "),
                  _c("span", { staticClass: "ae2-widget-menu-username" }, [
                    _vm._v(_vm._s(_vm.username))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "ae2-widget-menu-btn ae2-widget-menu-btn__primary",
                  on: { click: _vm.navigateMyAccount }
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.buttonsConfig.accountBtnText))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "ae2-widget-menu-btn ae2-widget-menu-btn__secondary",
                  on: { click: _vm.logout }
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.buttonsConfig.signoutBtnText))
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "ae2-widget-menu-group" }, [
          _c(
            "button",
            {
              staticClass: "ae2-widget-menu-btn ae2-widget-menu-btn__checkout",
              on: { click: _vm.showCheckoutModal }
            },
            [
              _c("span", { staticClass: "text" }, [
                _c("i", {
                  staticClass: "ae2-wdiget-menu-btn-icon",
                  class: _vm.iconCode
                }),
                _vm._v(" "),
                _c("span", { staticClass: "ae2-widget-menu-btn-description" }, [
                  _vm._v("Carrinho de Compras")
                ])
              ])
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ae2-widget-menu-message" }, [
      _c("p", { staticClass: "ae2-widget-menu-title text" }, [
        _vm._v("Bem-vindo!")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "ae2-widget-menu-subtitle text" }, [
        _vm._v("Não possui uma conta?")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }